
import { Component, Prop, Vue } from "vue-property-decorator";
import { mapGetters } from "vuex";
import bus from '../../eventBus'
import { namespace } from "vuex-class";
import ErrorNotification from "../shared/ErrorNotification.vue";
const profile = namespace("profile");

@Component({
  components: {ErrorNotification},
  computed: {
    ...mapGetters(["oidcUser"]),
  },
})
export default class Admin extends Vue {
  oidcUser!: any;
  
  userName: string ="";

  @profile.State
  public profileData!: any;
  @profile.State
  isAdmin!: boolean;
  @profile.State
  isStaffManager!: boolean;
 
  token = localStorage["Token"];

  userId: string = "";
  errorMsg: string = "";
  showErrorMsg: boolean = false;
  errorType: string = "error";
                  

  constructor() {
    super();
    
    bus.$on("profileLoaded", (msg) => {
      this.token = localStorage["Token"];
      this.updateUserName();
    });
  }

  async created()
  {
    if(this.profileData.first == null || this.profileData.first == undefined)
    {
      await this.$store.dispatch('profile/getProfileDetails','') ;   
    }
      if(!this.isAdmin)
      {
        this.$router.push('/invalidaccount')
      }
  }

  updateUserName()
  {
    if (this.profileData.first != null) {
      this.userName = this.profileData.first + " " + this.profileData.last;
    } 
    else {
      this.userName = this.oidcUser.firstName + " " + this.oidcUser.lastName;
    }
  }

  async saveUserId() {    
     this.showErrorMsg = false;
    if (this.userId != "") {
      await this.$store.dispatch("profile/checkStaffManager",this.userId.trim().toUpperCase()).then(async(res) => {                 
                 if(this.isStaffManager)
                 {
                    await this.$store.dispatch("profile/getProfileDetails", this.userId.trim().toUpperCase()); 
                 } 
                 else
                 {
                    this.showErrorMsg = true;
                    this.errorMsg = "The 3/4 ID you entered does not match any employees within your department(s). Please check the number and try again."
                    return;
                 }            
             })     
       this.$notify({
        group: "userid",
        title: "",
        text: `User 3/4 id (${this.userId}) saved successfully!`,       
      });         
      this.userId = "";
    }
  }
}
